export const getStoykaName = () => {
    if (!servObj.redactorModeObject) {
        console.warn("servObj.redactorModeObject ещё не создан!");
        return;
    }
    return servObj.redactorModeObject.name.split("__")[1];
};
